import { createStoreWithProducer } from '@xstate/store';
import { create } from 'mutative';

import { type FeatureFlag } from '~/constants/featureFlags';

import { type Permission } from '~/types/permission';

import { type User as UserQueryResponse } from '~/data/user';

type CurrentUser = Omit<UserQueryResponse, 'totalPermissions'> & {
  featureFlags: Record<FeatureFlag, boolean>;
  hasLoggedInViaSso: boolean;
  name: string;
  permissions: Permission[];
};

export const globalState = createStoreWithProducer(create, {
  context: {
    currentUser: undefined as CurrentUser | undefined,
  },
  on: {
    setCurrentUser(
      context,
      event: {
        currentUser: UserQueryResponse;
        hasLoggedInViaSso: boolean;
      },
    ) {
      const { companyAccount, firstName, lastName, totalPermissions, ...rest } =
        event.currentUser;

      context.currentUser = {
        ...rest,
        featureFlags: {
          ...companyAccount?.data?.featureFlags, // company-level feature flags
          ...rest?.settings?.featureFlags, // user-level feature flags
        },
        firstName,
        hasLoggedInViaSso: Boolean(event.hasLoggedInViaSso),
        lastName,
        name: [firstName, lastName].filter(Boolean).join(' '),
        permissions: totalPermissions,
      };
    },
  },
});
